export function isFullscreen(): boolean {
  return typeof document !== 'undefined' && document.fullscreenElement !== null;
}

/** False on iPhone Safari, which has no Fullscreen API for pages: the play screen leaves its button out there. */
export function canFullscreen(): boolean {
  return typeof document !== 'undefined' && document.fullscreenEnabled === true;
}

export async function toggleFullscreen(): Promise<void> {
  try {
    if (isFullscreen()) {
      await document.exitFullscreen();
      return;
    }
    await document.documentElement.requestFullscreen();
  } catch {
    // Refused (an iframe without allow="fullscreen", say); the button simply does nothing then.
    return;
  }
  await lockLandscape();
}

// Android Chrome can hold the screen in landscape, but only in full screen;
// leaving full screen releases the lock by itself. Desktop browsers refuse
// the lock, which leaves full screen as it is.
async function lockLandscape(): Promise<void> {
  const orientation = screen.orientation as ScreenOrientation & { lock?: (orientation: 'landscape') => Promise<void> };
  try {
    await orientation.lock?.('landscape');
  } catch {
    // Not supported here (desktop), or refused.
  }
}
